import { UserSignUpService } from "../Infrastructure/Auth.service";
import { createPassword } from "../../User/Domain/User.model";

export default async function SignUpLogic(info) {
    const tempPass = createPassword();
    return UserSignUpService({...info, password: tempPass});
}

